import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle, ArrowRight, Sparkles, LogOut, Gift } from 'lucide-react';
import { toast } from 'sonner';

const LOGO_URL = "https://customer-assets-rejwkqb3.emergentagent.net/job_5700d295-d3ed-4629-8765-e98307778f89/artifacts/bbyq8lme_icone_verre_vert_512.png";

const ActivateTrialPage = ({ user, onTrialActivated, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (onLogout) onLogout();
    toast.success('Déconnexion réussie');
    navigate('/');
  };

  const handleContinue = () => {
    if (onTrialActivated) onTrialActivated();
    navigate('/creer-copropriete');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-emerald-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Bouton déconnexion en haut à droite */}
        <div className="flex justify-end mb-4">
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 text-slate-500 hover:text-red-600 transition-colors text-sm"
            data-testid="logout-button-trial"
          >
            <LogOut className="w-4 h-4" />
            Se déconnecter
          </button>
        </div>

        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-4">
            <img 
              src={LOGO_URL} 
              alt="copropriete.app" 
              className="w-14 h-14 rounded-2xl shadow-lg"
            />
            <span className="text-2xl font-bold text-slate-900">copropriete.app</span>
          </div>
        </div>

        {/* Card principale */}
        <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-emerald-500 to-teal-500 p-6 text-white text-center">
            <div className="inline-flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full mb-4">
              <Sparkles className="w-5 h-5" />
              <span className="font-medium">Bienvenue {user?.prenom || ''} !</span>
            </div>
            <h1 className="text-2xl font-bold mb-2">Votre espace est prêt</h1>
            <p className="text-emerald-100">100% gratuit, sans limite</p>
          </div>

          {/* Contenu */}
          <div className="p-6">
            {/* Avantages */}
            <div className="space-y-3 mb-6">
              {[
                'Gestion complète de votre copropriété',
                'Appels de fonds automatiques',
                'Assistant juridique IA',
                'Coffre-fort documentaire illimité',
                'Convocations et PV d\'AG',
                'Vote en direct pendant les AG'
              ].map((feature, i) => (
                <div key={i} className="flex items-center gap-3 text-slate-700">
                  <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            {/* Info gratuit */}
            <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 mb-6">
              <div className="flex items-start gap-3">
                <Gift className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-medium text-emerald-800">Tout est gratuit</p>
                  <p className="text-sm text-emerald-700">
                    Pas d'abonnement, pas de carte bancaire. Gérez votre copropriété en toute liberté.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <Button 
              onClick={handleContinue}
              className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-6 text-lg font-semibold rounded-xl"
              data-testid="start-button"
            >
              Créer ma copropriété
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>

        {/* Footer info */}
        <p className="text-center text-slate-500 text-sm mt-6">
          Déjà une copropriété ? Elle apparaîtra automatiquement.
        </p>
      </div>
    </div>
  );
};

export default ActivateTrialPage;
